import { SectionType } from '../../../features/invoice-theme/theme.types';
import { recordToKvArray } from '../../../shared/functions/record-functions';
import { Tuple } from '../../../shared/data-structures/tuple';
import { ContentArea } from '../../../core/models/invoice/invoice-document-detail.model';
import { BaseInvoiceThemeModel } from '../../../core/models/invoice/base-invoice-theme.model';

/** Turns a Map<string, ContentArea> into the server array for "content-areas" */
export const mapToContentAreasArray = (map?: Map<string, ContentArea>) =>
  map
    ? Array.from(map.entries()).map(([key, area]) => ({
        key,
        type: area?.type ?? SectionType.HTML,
        content: area?.content ?? '',
        meta: recordToKvArray(area?.meta),
      }))
    : [];

export const convertToContentAreaMap = (arr: any[]) => {
  const map = new Map();

  arr.forEach((item) => {
    const meta = item.meta;

    const metaObj = Array.isArray(meta)
      ? meta.reduce((m, metaItem) => {
          m[metaItem.key] = metaItem.value;
          return m;
        }, {})
      : meta || {};

    const contentArea = {
      id: item.id,
      type: item.type,
      content: item.content,
      meta: metaObj,
    };

    map.set(item.key, contentArea);
  });

  return map;
};

/** If theme model is a plain object, this converts it to [{key,value}] */
export const themeToKvArray = (theme?: BaseInvoiceThemeModel) =>
  theme ? recordToKvArray(theme as unknown as Record<string, unknown>) : [];

export const convertToThemeObject = (arr: Tuple[]) => {
  const obj = arr.reduce((acc, { key, value }) => {
    acc[key] = value;
    return acc;
  }, {} as any);

  // Create class instance
  return Object.assign(new BaseInvoiceThemeModel(), obj);
};
